import React, { useEffect, useState, useRef } from 'react';

import { isClientSide } from "@utils";

const DEIPageClusterChartCanvas = ({
  circles,
  isInitialized,
  width,
  height,
}) => {
  const canvasRef = useRef();
  const ctxRef = useRef();
  const [dpr, setDpr] = useState(1);

  useEffect(() => {
    if (!isClientSide()) return;

    const _dpr = window.devicePixelRatio || 1;

    setDpr(_dpr);

    const canvas = canvasRef.current;
    ctxRef.current = canvas.getContext('2d');
  }, []);

  useEffect(() => {
    if (!isClientSide()) return;

    const draw = ctx => {
      ctx.clearRect(0, 0, ctx.canvas.width * 1.5, ctx.canvas.height * 1.5);
      ctxRef.current.setTransform(dpr, 0, 0, dpr, 0, 0);

      circles.forEach(circle => {
        if (circle.filtered) return;

        ctx.beginPath();
        ctx.fillStyle = circle.color;
        ctx.strokeStyle = '#FFFFFF';
        ctx.arc(circle.x, circle.y, circle.r, 0, 2 * Math.PI);
        ctx.fill();
        ctx.stroke();
      });
    }

    let animationFrameId;

    const render = () => {
      draw(ctxRef.current);
      animationFrameId = window.requestAnimationFrame(render);
    }
    render();

    return () => {
      window.cancelAnimationFrame(animationFrameId);
    }
  }, [circles, dpr]);

  return (
    <canvas
      ref={canvasRef}
      width={width * dpr}
      height={height * dpr}
      style={{
        opacity: isInitialized ? 1 : 0,
        transition: 'opacity 1s',
      }}
    />
  )
}

export default DEIPageClusterChartCanvas;
